import React from "react";
import styled from "styled-components";
import { path } from "ramda";

const getUsername = path(["sources", 0, "name"]);

const SupportUs = ({ user }) => (
  <Container>
    <Subtitle>
      <b>Whoa!</b>
      {" "}
Top Nine is currently being used by millions of users worldwide.
      <br />
      <br />
      To ensure you get your Top Nine in seconds, the web version of Top Nine needs your support
      (our mobile apps are still free though!)
      <br />
      <br />
      {" "}
Please checkout to continue. You will receive the Top Nine image for
      {" "}
      <b>
@
        {getUsername(user)}
      </b>
      {" "}
to
      <b>{user ? user.email : ""}</b>
      {" "}
seconds after your purchase.
    </Subtitle>
    <FooterContainer />
  </Container>
);

const Container = styled.div`
  margin-top: 40px;
`;

const FooterContainer = styled.div`
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0px 30px 0px;
`;

const Subtitle = styled.p`
  padding: 10px 30px;
  color: #303030;
  text-align: center;
  font-size: 14;
  font-family: Montserrat;
  font-weight: 400;
  b {
    color: #f74255;
  }
`;

export default SupportUs;
